import AppMenu from './AppMenu';

function AppSidebar() {
  return <AppMenu />;
}

export default AppSidebar;
